import { render, staticRenderFns } from "./FieldHistoryViewer.vue?vue&type=template&id=82dc85ca&scoped=true"
import script from "./FieldHistoryViewer.vue?vue&type=script&lang=js"
export * from "./FieldHistoryViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82dc85ca",
  null
  
)

export default component.exports